
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { ApprovalState, Contact, Group, GroupSurveyExtension, GroupSurveyExtensionApproval } from '../../../../backend/backendapi';
import { camelCase, formatDateTime } from '../../../../../util';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import ContactStore from '../../../../../stores/ContactStore';

type DDContact = { contact: Contact; label: string; }

@Component({
  components: {
    vSelect,
  },
})
export default class Approval extends Vue {
  @Prop({ required: true })
  readonly group!: GroupSurveyExtension;
  @Prop({ required: true })
  readonly approval!: GroupSurveyExtensionApproval;
  @Prop({ required: true })
  readonly approvalGroups!: Group[];
  @Prop({ default: false })
  readonly hideApprovalStatus!: boolean;

  readonly contactsStore = new ContactStore();

  camelCase = camelCase;
  formatDateTime = formatDateTime;
  ApprovalState = ApprovalState;

  get approvedByContact(): Contact | null {
    if (!this.approval.approvedByContactId) {
      return null;
    }
    return this.contactsStore.contacts
        .find(e => e.id === this.approval.approvedByContactId) ?? Contact.fromJS({ firstName: this.approval.approvedByContactId });
  }

  get contacts(): DDContact[] {
    return this.contactsStore.contacts.map(e => ({ contact: e, label: (e.firstName ?? '') + ' ' + (e.lastName ?? '') + ' (' + (e.email ?? '') + ')' }));
  }

  async mounted(): Promise<void> {
    await this.contactsStore.loadIfAbsent();
  }
}
